<template>
    <div  class="map-list-item-flex" @click="itemClicked" :title="this.nimi">
      <div class='dev-indicator' :style="{'background-color': this.deviationColor}"></div>
      <div class='vehicle'>
        <img v-if="this.vehicleType == 'bus'" class="icon-img" src="/traveller-ui/map/images/icons/bus.svg" />
        <img v-if="this.vehicleType == 'tram'" class="icon-img" src="/traveller-ui/map/images/icons/ratikka_02_plain.svg" />
        <img v-if="this.vehicleType == 'trolleybus'" class="icon-img" src="/traveller-ui/map/images/icons/trolleybus.svg" />
      </div>
      <div class="id">{{ this.nimi }}</div>
      <div class="block">{{ this.block }}</div>
      <div class="line">{{ this.lineLabel }}</div>
      <div v-if="$UiConfig('/data/departure/showCourse', false)">{{ this.tripShortName }}</div>
      <div class='dev'>{{ this.deviation }}</div> 
  </div>
</template>

<script>
import system from  '@/store/system/system'
import realtimeLogic from '@/services/realtimeLogic'

export default {
  name: 'MapVehicleEntry',
  props: {
   entry: {type: Object}
  },
  data: function() {
    return {
      entryData: null,
      deviationColor: null,
      defaultData: {tunnus:"-", nimi:"-"}
    }
  },
  beforeCreate: function() {
   if (!this.$store.state.system) {
     this.$store.registerModule("system" , system);
   }
  },
  created() {
    this.entryData = Object.assign(this.defaultData,this.entry);
    if(this.$route.query.vehicleLabel && this.$route.query.vehicleLabel == this.entryData.vehicleLabel) {
      this.$route.query.vehicleLabel = undefined;
      this.itemClicked();
    }
  }, 
  mounted: function() { 
        this.$store.dispatch('mapstore/system/getDeviationColors').then(data => {
        this.deviationColor = data[this.deviationClass].primarycolor;
      }).catch(()=>{});

  },
  computed: {
    nimi: function() {
      try{
        //if(this.entryData.vehicleLabel.length <= 13) {
          return this.entryData.vehicleLabel;
        //} else {
        //  return this.entryData.vehicleLabel.substring(0,12) + "...";
        //}
      }catch(err) {
        return "";
      }
    },
    tunnus: function() {
      try{
        return this.entryData.computerLabel.substring(0,8);
      } catch(err) {
        return "";
      }
    },
    block: function() {
      try {
        if(this.entryData.spatialData.properties.blockSequence != null)
          return this.entryData.spatialData.properties.blockSequence;
        else
          return "";
      }catch(err) {return "";}
    },
    lineLabel: function() {
      try {
        return this.entryData.spatialData.properties.lineLabel;
      }catch(err) {return "";}
    },
    tripShortName: function() {
        try {
            return this.entryData.spatialData.properties.tripShortName;
        } catch(err) {
            return '';
        }
    },
    deviationClass: function() {
      try {
        return this.entryData.spatialData.properties.deviation_class;
      } catch(err) {return null;}
      //var class = entryData;
    },
    vehicleType: function() {
      try {
        if(this.entryData.features.VEHICLE_TYPE == 'Tramwaj') {
          return "tram";
        } else if (this.entryData.features.VEHICLE_TYPE == 'Trolejbus') {
          return "trolleybus"
        }
      } catch(err) {/*Do nothing*/}

      return "bus";
    },
    vehicleRealtimeStatus: function() {
      try {
        switch(this.this.entryData.spatialData.properties.realtimeStatus) {
          case 'ok':
            return 'ok';
          case 'no_driving_cycles':
            return 'no_driving_cycles';
          case 'no_gps':
            return 'no_gps';
          case 'inactive':
            return 'inactive';
          case 'unknown':
            return 'unknown';
          default:
            return null;
          }
      } catch(err) {/*Do nothing*/}
      
      return "unknown";
    },
    deviation: function() {
      try{
        return realtimeLogic.getDeviationInRightFormat(this.entryData.spatialData.properties.lastSeenTime, this.entryData.spatialData.properties.deviation, this.entryData.spatialData.properties.blockSequence)
      }catch(err){
        return "";
      }
      }
    },
  methods: {
    itemClicked() {
      this.$emit('click', this.entryData.vehicleId);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.id {
  min-width: 60px;
}

.line {
  min-width: 50px;
  max-height: 20px;
  margin-left: 10px;
}


.block {
max-width: 90px;
min-width: 60px;
}
</style>
